import { Button, Stack, Typography } from "@mui/material";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import ResultGraph from "src/assets/ResultGraph";
import { theme } from "src/assets/theme";
import { useProduct } from "src/context/ProductProvider";
import { useIsMobile } from "src/hooks/useIsMobile";

const percentages: Record<string, string> = {
  Semaglutide: "20%",
  Tirzepatide: "25%",
  Metformin: "5%",
  "Insurance GLP-1": "20%",
  "Wegovy Pills": "20%",
  "Oral Semaglutide": "20%",
};

interface Props {
  onNavigate: () => void;
}

const ResultExpectation = ({ onNavigate }: Props) => {
  const isMobile = useIsMobile();
  const productSlug = useProduct((p) => p.slug);
  const name = useProduct((p) => p.display_name);
  const { t } = useTranslation();
  const page = "welcome-2";

  const percentage = useMemo(() => percentages[name], [name]);

  return (
    <Stack alignItems="center" gap={2} p={1}>
      <Stack
        p={isMobile ? 2 : 3}
        height="80%"
        width="100%"
        sx={{
          backgroundColor: theme.palette.primary.main,
          borderRadius: "30px",
        }}
        gap={isMobile ? 0 : 2}
        onClick={onNavigate}
      >
        <Stack gap={2}>
          <Typography color="#005765" variant="h3" fontWeight={600} mt={3}>
            {t(`${page}.title1`)}{" "}
            <span style={{ color: "#ffffff" }}>{percentage}</span>{" "}
            {t(`${page}.title2`)}
          </Typography>
          <Typography color="#ffffff" variant="body1" fontWeight={600}>
            {t(`${page}.${productSlug}.subtext`)}
          </Typography>
        </Stack>
        <ResultGraph width="100%" label={t(`${page}.goalWeight`)} />
      </Stack>
      <Stack gap={3} mt={2}>
        <Typography variant="subtitle2">
          {t(`${page}.${productSlug}.disclaimer`)}
        </Typography>
        <Button variant="contained" onClick={onNavigate} fullWidth>
          {t(`button.next`)}
        </Button>
      </Stack>
    </Stack>
  );
};

export default ResultExpectation;
